import { z } from 'zod'
import { oc } from '@orpc/contract'
import { eventIterator } from '@orpc/contract'
import {
  actorOverrideSchema,
  streamingSchema,
  threadPathSchema,
} from './assistant-conversation.contract'
import { threadEntrySchema } from './user-facing-entry.contract'

// Entries on the wire are the grouped `threadEntrySchema`, identical to the
// static `assistantGet` shape, so the frontend's entry-merge code stays shared.
// In debug mode each turn carries its full `processing`; in normal mode the
// projection reduces it to the latest thinking step — both are valid instances
// of the same schema. `streaming` is present iff the turn is still in flight —
// the terminal frame omits it and signals the client to close the connection.
export const assistantStreamEventSchema = z
  .object({
    entries: z.array(threadEntrySchema),
    streaming: streamingSchema.optional(),
  })
  .strict()

export const assistantStream = oc
  .route({ method: 'GET', path: '/v2/assistant/conversations/thread/stream' })
  .input(
    z.object({
      threadPath: threadPathSchema,
      sinceId: z.string().optional(),
      actor: actorOverrideSchema,
    }),
  )
  .output(eventIterator(assistantStreamEventSchema))
